/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetKeyEnabledRequestBody,
  SetKeyEnabledRequestBody$Outbound,
  SetKeyEnabledRequestBody$outboundSchema,
} from "../components/setkeyenabledrequestbody.js";

export type SetModelProviderKeyEnabledSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetModelProviderKeyEnabledSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetModelProviderKeyEnabledSecurity = {
  option1?: SetModelProviderKeyEnabledSecurityOption1 | undefined;
  option2?: SetModelProviderKeyEnabledSecurityOption2 | undefined;
};

export type SetModelProviderKeyEnabledRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setKeyEnabledRequestBody: SetKeyEnabledRequestBody;
};

/** @internal */
export type SetModelProviderKeyEnabledSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetModelProviderKeyEnabledSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetModelProviderKeyEnabledSecurityOption1$Outbound,
    SetModelProviderKeyEnabledSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setModelProviderKeyEnabledSecurityOption1ToJSON(
  setModelProviderKeyEnabledSecurityOption1:
    SetModelProviderKeyEnabledSecurityOption1,
): string {
  return JSON.stringify(
    SetModelProviderKeyEnabledSecurityOption1$outboundSchema.parse(
      setModelProviderKeyEnabledSecurityOption1,
    ),
  );
}

/** @internal */
export type SetModelProviderKeyEnabledSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetModelProviderKeyEnabledSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetModelProviderKeyEnabledSecurityOption2$Outbound,
    SetModelProviderKeyEnabledSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setModelProviderKeyEnabledSecurityOption2ToJSON(
  setModelProviderKeyEnabledSecurityOption2:
    SetModelProviderKeyEnabledSecurityOption2,
): string {
  return JSON.stringify(
    SetModelProviderKeyEnabledSecurityOption2$outboundSchema.parse(
      setModelProviderKeyEnabledSecurityOption2,
    ),
  );
}

/** @internal */
export type SetModelProviderKeyEnabledSecurity$Outbound = {
  Option1?: SetModelProviderKeyEnabledSecurityOption1$Outbound | undefined;
  Option2?: SetModelProviderKeyEnabledSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetModelProviderKeyEnabledSecurity$outboundSchema: z.ZodMiniType<
  SetModelProviderKeyEnabledSecurity$Outbound,
  SetModelProviderKeyEnabledSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetModelProviderKeyEnabledSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetModelProviderKeyEnabledSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setModelProviderKeyEnabledSecurityToJSON(
  setModelProviderKeyEnabledSecurity: SetModelProviderKeyEnabledSecurity,
): string {
  return JSON.stringify(
    SetModelProviderKeyEnabledSecurity$outboundSchema.parse(
      setModelProviderKeyEnabledSecurity,
    ),
  );
}

/** @internal */
export type SetModelProviderKeyEnabledRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetKeyEnabledRequestBody: SetKeyEnabledRequestBody$Outbound;
};

/** @internal */
export const SetModelProviderKeyEnabledRequest$outboundSchema: z.ZodMiniType<
  SetModelProviderKeyEnabledRequest$Outbound,
  SetModelProviderKeyEnabledRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setKeyEnabledRequestBody: SetKeyEnabledRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setKeyEnabledRequestBody: "SetKeyEnabledRequestBody",
    });
  }),
);

export function setModelProviderKeyEnabledRequestToJSON(
  setModelProviderKeyEnabledRequest: SetModelProviderKeyEnabledRequest,
): string {
  return JSON.stringify(
    SetModelProviderKeyEnabledRequest$outboundSchema.parse(
      setModelProviderKeyEnabledRequest,
    ),
  );
}
